var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "questionnaireQuestion list", class: _vm.classes },
    [
      _c("div", { staticClass: "questionnaireQuestionLabel list" }, [
        _c(
          "span",
          { staticClass: "questionnaireQuestionLabelOrd", class: _vm.classes },
          [_vm._v(_vm._s(_vm.template.ord) + ".")]
        ),
        _c("span", [_vm._v(_vm._s(_vm.template.name))]),
      ]),
      _c(
        "div",
        { staticClass: "questionnaireQuestionOptions" },
        [
          _vm._l(_vm.template.options, function (option, oIndex) {
            return [
              _c(
                "label",
                { key: oIndex, staticClass: "questionnaireQuestionOption" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "questionnaireQuestionOptionText",
                      class: { on: _vm.value === option.value },
                    },
                    [
                      _vm._v(" " + _vm._s(option.label) + " "),
                      _vm.isUserDefined
                        ? _c("span", [_vm._v("(" + _vm._s(option.value) + ")")])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _c("tooltip", {
        attrs: {
          ord: _vm.template.ord,
          title: _vm.template.name,
          description: _vm.template.description,
          required: !!_vm.isRequired,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }